// extracted by mini-css-extract-plugin
export default {"img":"ContactSupport_img__X5lIF","container":"ContactSupport_container__13d6V"};